var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[[_c('ExhibitionSelector',{attrs:{"on-change":_vm.onExhibitionChange}}),(_vm.exhibition)?_c('ExhibitionItemList',{attrs:{"bus":_vm.busses.exhibitionItem,"exhibitionId":_vm.exhibition.id}}):_vm._e()]],2)}
var staticRenderFns = []

export { render, staticRenderFns }